import { render, staticRenderFns } from "./NavbarAltLinks.html?vue&type=template&id=3d528e9a&"
import script from "./NavbarAltLinks.ts?vue&type=script&lang=ts&"
export * from "./NavbarAltLinks.ts?vue&type=script&lang=ts&"
import style0 from "./NavbarAltLinks.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports